import { Button } from "@components/ui/Button"
import { Field } from "@components/ui/Field"
import { Input } from "@components/ui/Input"
import { useState } from "react"
import { useAuth } from "../useAuth"
import { alerts } from "@utils/alerts"
import { AlertDialog } from "@components/ui/AlertDialog"

type Props = {}

function validatePassword(password: string) {
  return password.length >= 8 && /[a-zA-Z]/.test(password) && /[0-9]/.test(password)
}

export function ChooseNewPassword(props: Props) {
  const auth = useAuth()
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  return (
    <AlertDialog
      title="Choose a new password"
      description="Enter your new password below"
      open
      canDismiss
      cancelButton="Cancel"
      onOpenChange={(open) => {
        if (!open) {
          auth.closeModal()
        }
      }}
      onCancel={() => {
        auth.closeModal()
      }}
      confirmButton={
        <Button type="submit" disabled={!validatePassword(password)} loading={submitting}>
          Update password
        </Button>
      }
      onConfirm={async () => {
        if (!validatePassword(password)) {
          setError("Password does not meet requirements")
          setSubmitting(false)
          return false
        }
        setError(null)
        setSubmitting(true)
        await auth.api.auth
          .updateUser({ password })
          .then((result) => {
            if (result.error) {
              setError(result.error.message)
            } else {
              auth.closeModal()
              alerts.displayAlert({
                title: "Password updated",
                description: "Your password has been updated successfully.",
              })
            }
          })
          .finally(() => {
            setSubmitting(false)
          })
      }}
    >
      <Field
        label="New Password"
        required
        help={"Must be at least 8 characters long, and contain letters and numbers"}
        error={error!}
      >
        <Input
          type="password"
          stretch
          className="w-full"
          value={password}
          required
          onValueChange={setPassword}
          placeholder=""
        />
      </Field>
    </AlertDialog>
  )
}
